import { ToastsService, ErrorMediator, Datable } from "@a365/ui/services";
import type { IToastsService, IToastOptions, ToastType, IToastData } from "@a365/ui/services";

export class ToastService implements IToastsService {
  private toastsService: ToastsService;

  constructor() {
    this.toastsService = new ToastsService(new ErrorMediator());
  }

  showToast(text: string, options?: IToastOptions): void;
  showToast(text: string, type?: ToastType, autocloseDelay?: number): void;
  showToast(text: string, optionsOrType?: ToastType | IToastOptions, autocloseDelay?: number): void {
    let options = this.getDefaultOptions();
    if (typeof optionsOrType === 'string') {
      options.type = optionsOrType;
      if (autocloseDelay != null)
        options.autocloseDelay = autocloseDelay;
    }
    else if (optionsOrType != null)
      options = { ...options, ...optionsOrType };

    this.toastsService.showToast(text, options);
  }

  showError(text: string, options?: IToastOptions): void;
  showError(text: string, autocloseDelay?: number): void;
  showError(text: string, optionsOrAutoCloseDelay?: IToastOptions | number): void {
    let options = this.getDefaultOptions('error');
    if (typeof optionsOrAutoCloseDelay === 'number')
      options.autocloseDelay = optionsOrAutoCloseDelay;
    else if (optionsOrAutoCloseDelay != null)
      options = { ...options, ...optionsOrAutoCloseDelay };

    this.toastsService.showToast(text, options);
  }

  hideToast(): void {
    this.toastsService.hideToast();
  }

  get toastData(): Datable<IToastData> {
    return this.toastsService.toastData;
  }

  private getDefaultOptions(type?: ToastType): IToastOptions {
    return {
      autoclose: true,
      autocloseDelay: 5000,
      hideClose: true,
      placement: 'top',
      type: type ?? 'info',
    };
  }
}
